export default "__VITE_ASSET__C9KQhXPh__"